import { render, staticRenderFns } from "./HighlightStatsCustomer.vue?vue&type=template&id=26135ff8&scoped=true"
import script from "./HighlightStatsCustomer.vue?vue&type=script&lang=js"
export * from "./HighlightStatsCustomer.vue?vue&type=script&lang=js"
import style0 from "./HighlightStatsCustomer.vue?vue&type=style&index=0&id=26135ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26135ff8",
  null
  
)

export default component.exports